import reduceReducers from "reduce-reducers";

import { BUSINESS_REGISTRATION } from "constants/actionTypes";

import {
  offlineCrudReducer,
  resetStateOnRoleChangeReducer,
} from "lib/reducers";
import { deserializeBusinessRegistration as deserializer } from "lib/serializers/businessRegistrations";

const businessRegistrationsCrudReducer = offlineCrudReducer(
  BUSINESS_REGISTRATION,
  {
    deserializer,
  },
);

const businessRegistrationsReducer = reduceReducers(
  businessRegistrationsCrudReducer,
  resetStateOnRoleChangeReducer,
);

export default businessRegistrationsReducer;
